import { createReducer, on } from '@ngrx/store';
import { MyProfileActions } from '../actions';
import { updateTableState } from '../my-profile-state';

export const initialTableState: updateTableState = {
    loading: null,
    success: null,
    error: null,
    tableData: [],
    comment: ''
};

export const tableReducer = createReducer(
    initialTableState,
    on(MyProfileActions.checkDataInTable, (state: updateTableState, { tableData }) => ({
        ...state,
        tableData,
    })),
    on(MyProfileActions.addComment, (state: updateTableState, { comment }) => {
        return {
            ...state,
            comment: comment
        };
    }),
    on(MyProfileActions.submitRequestAccess, (state: updateTableState, { comment }) => ({
        ...state,
        loading: true,
        success: null,
        error: null,
        comment
    })),
    on(MyProfileActions.submitRequestAccessSuccess, (state: updateTableState) => ({
        ...state,
        loading: false,
        success: true,
        error: null,
        tableData: [],
        comment: ''
    })),
    on(MyProfileActions.submitRequestAccessFail, (state: updateTableState, { payload }) => ({
        ...state,
        loading: false,
        success: false,
        error: payload,
        tableData: [],
        comment: ''
    })),
    on(MyProfileActions.updateTableStateSuccessReset, (state: updateTableState) => {
        return {
            ...state,
            success: false,
        };
    }),
    on(MyProfileActions.payloadReset, (state: updateTableState) => ({
        ...state,
        loading: false,
        success: false,
        tableData: [],
        comment: ''
    })),
);
